import Homeview from "./components/homeview";
import Navbar from "./components/navbar";
import {BrowserRouter as Router, Route, Routes, useLocation, useSearchParams} from "react-router-dom"
import { useEffect, useState } from "react";
import { checkServerHealth } from "./components/serverManager";
import Custdataentry from "./components/custdataentry";
import Pagenotfound from "./components/pagenotfound";
import Listcustdata from "./components/listcustdata";
import Listtripsdata from "./components/listtripsdata";
import Hoteldataentry from "./components/hoteldataentry";
import Tourdataentry from "./components/tourdataentry";
import Custdataupdate from "./components/custdataupdate";
import Tripdataentry from "./components/tripdataentry";
import Tripdataupdate from "./components/tripdataupdate";
import Listhoteldata from "./components/listhoteldata";
import Listtourdata from "./components/listtourdata";
import Tourdataupdate from "./components/tourdataupdate";
import Hoteldataupdate from "./components/hoteldataupdate";
import Searchcust from "./components/searchcust"
import Authscreen from "./components/authscreen";
import Listsupplierdata from "./components/listsupplierdata";
import Supplierdataupdate from "./components/supplierdataupdate";
import Supplierdataentry from "./components/supplierdataentry";
import AuthContextProvider from "./components/authContext";
import {AppDataProvider} from "./components/appDataContext";
import Test from "./components/test"
import Searchtrip from "./components/searchtrip";
import Trippayments from "./components/payments";
import Trippaymentupdate from "./components/paymentupdate";
import Employeedataentry from "./components/employeedataentry";
import Employeedataupdate from "./components/employeedataupdate";
import Listemployeedata from "./components/listemployee";
import Listquotedata from "./components/listquotes";
import Quotedataentry from "./components/createquote";
import Quotedataupdate from "./components/updatequote";
import Viewquote from "./components/viewquote";
import Reusequote from "./components/reusequote";
import Analyticsdata from "./components/analytics";
import Searchhotel from "./components/searchhotel"
import Knowledge from "./components/knowledge";
import Lead from "./components/lead";
import Duptripentry from "./components/duptripentry";
import Leaddataupdate from "./components/updateLead";
import Analyticsdata2 from "./components/analytics2";
import Invoice from "./components/invoice";
import PostSales from "./components/postsales";
import BulkWA from "./components/bulkwa";
import Viewvoucher from "./components/voucher";
import Leadtripdataentry from './components/leadtripdataentry'
import Dashboard from './components/dashboard'
import Dubai from "./knowledge/dubai";
import Kazakhstan from "./knowledge/kazakhstan";
import Himachal from "./knowledge/himachal";
import Andaman from "./knowledge/andaman";
import Goa from "./knowledge/goa";
import Indonesia from "./knowledge/indonesia";
import Kashmir from "./knowledge/kashmir";
import Vietnam from "./knowledge/vietnam";
import Azerbaijan from "./knowledge/azerbaijan";
import Kerala from "./knowledge/kerala";
import Malaysia from "./knowledge/malaysia";
import Sikkim from "./knowledge/sikkim";
import Singapore from "./knowledge/singapore";
import SriLanka from "./knowledge/srilanka";
import Thailand from "./knowledge/thailand";
import Turkey from "./knowledge/turkey";
import Ladakh from "./knowledge/ladakh";
import Info from "./components/info";
import Marketing from "./components/marketing";
import RezliveSearch from "./components/rezlivesearch";
import RezliveBook from "./components/rezlivebook";
import RezliveView from "./components/rezliveview"
import TBOBook from "./components/tbobook";
import TBOSearch from "./components/tbosearch"
import TBOView from "./components/tboview"
import LeadRules from "./components/leadrules"
import Listassetdata from "./components/listasset"
import CreateTask from "./components/createtask";
import UpdateTask from "./components/taskupdate";
import Listtaskdata from "./components/listtask";
import Productanalytics from "./components/productanalytics";
import ProductBased from "./components/productbased";
import Supplierdatarecord from "./components/supplierrecord";
import Salessupport from "./components/salessupport";
import TLHome from "./components/tlhome";
import Listfddata from "./components/listfddata";
import Fdentry from "./components/fdentry";
import Fd from "./components/fdupdate";
import Listhrdata from "./components/listhrdata";
import Canddataentry from "./components/canddataentry";
import Canddataupdate from "./components/canddataupdate";
import Chat from "./components/chat";
import Duptourentry from "./components/duptourdataentry";
import HotelVoucher from "./components/hotelvoucher";
import Project from "./components/project";
import Leadentry from "./components/leadcaptureform";

function App() {
useEffect(() => {
    checkServerHealth(); // check at startup

    const interval = setInterval(() => {
      checkServerHealth();
    }, 5 * 60 * 1000); // every 5 mins

    return () => clearInterval(interval);
  }, []);
//   const [router, setrouter] = useState(false);
//   const currenturl = window.location.href;
//   const urlarray = currenturl.split("?token=");
//   const token = urlarray[urlarray.length - 1];
//   // const location = useLocation();
//   console.log(token)
//   // const [searchParams] = useSearchParams();
//   // const token = searchParams.get("token");
// // export {User}
// useEffect(() => {
//   // console.log(window.location.search)
//   console.log(auth)
//   // const urlParams = new URLSearchParams(window.location.search);
//   // console.log(urlParams)
//   // const token = urlParams.get('token');
//   console.log(token)
//   // const expiresAt = urlParams.get('expiresAt');
//   if (token) {
//     try {
//         // Decode the token (no need to verify it here, just decoding to extract user info)
       

        
//         async function verify(token){
//           const response = await fetch(url+'/verifytoken', {
//             method: 'POST',
//             body: JSON.stringify({ token }),
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });
//         console.log(response)
//         if (response.ok) {
//             const userData = await response.json();
//             // Set the user data in the app (e.g., in the state or localStorage)
//             console.log('User authenticated:', userData);
//             auth.currentUser = userData.email
//             window.location = ("/home");
//         } else {
//             throw new Error('Invalid token');
//         }
//         }

//         const decodedToken = jwtDecode(token);

//         // Check if token is still valid (you can also verify the token with the backend if needed)
//         const currentTime = Math.floor(Date.now() / 1000);
//         if (decodedToken.exp < currentTime) {
//             throw new Error('Token has expired');
//         }else{
//           verify(token)
//         }
//         // Automatically log in the user
//         // Assuming you have a backend endpoint to authenticate the user with the token
       
//     } catch (error) {
//         console.error('Authentication failed:', error);
//     }
// } else {
//     console.log('No token found in URL');
//     setrouter(true)
// }
// }, []);

   return (
   
    
    <Router>
    <div className="App">
        
      <AuthContextProvider>
      <AppDataProvider>
      <Routes>
        <Route exact path="/" element={<Authscreen />  }>
          
        </Route>
        <Route exact path="/home"
        
        element={<> 
          <Navbar />
          <Homeview />   
          </>}>
          
           
        </Route>
        <Route exact path="/tlhome"
        
        element={<> 
          <Navbar />
          <TLHome />    
          </>}>
          
          
        </Route>
        <Route exact path="/info"
        
        element={<> 
          <Navbar />
          <Info/>     
          </>}>
         
           
        </Route>
        <Route exact path="/marketing"
        element={<> 
          <Navbar />
          <Marketing/>   
          </>}>
          
          
        </Route>
        <Route exact path="/flightapi"
        element={<> 
          <Navbar />
          <TBOSearch/>   
          </>}>
          
          
        </Route>
        <Route exact path="/salessupport"
        element={<> 
          <Navbar />
          <Salessupport/>    
          </>}>
         
          
        </Route>
        <Route exact path="/leadcaptureform"
        element={<> 
          <Navbar />
          <Leadentry />   
          </>}>
          
          
        </Route>
        <Route exact path="/chat"
        element={<> 
          <Navbar />
          <Chat/>    
          </>}>
          
          
        </Route>
        <Route exact path="/leadrules"
        element={<> 
          <Navbar />
          <LeadRules/>    
          </>}>
          
           
        </Route>
         <Route exact path="/hotelvoucher"
        element={<> 
          <Navbar />
          <HotelVoucher/>    
          </>}>
          
           
        </Route>
        <Route exact path="/flightbook"
        element={<> 
          <Navbar />
          <TBOBook/>    
          </>}>
         
          
        </Route>
        <Route exact path="/flightview"
        element={<> 
          <Navbar />
          <TBOView/> 
          </>}>
          
           
        </Route>
        <Route exact path="/hotelapi"
        element={<> 
          <Navbar />
          <RezliveSearch/>    
          </>}>
         
           
        </Route>
        <Route exact path="/hotelbook"
        element={<> 
          <Navbar />
          <RezliveBook/>     
          </>}>
         
         
        </Route>
        <Route exact path="/hotelview"
        element={<> 
          <Navbar />
          <RezliveView/>     
          </>}>
        
          
        </Route>
        <Route exact path="/knowledgecenter"
        element={<> 
          <Navbar />
          <Knowledge />   
          </>}>
          
        
        </Route>
        <Route exact path="/lead"
        element={<> 
          <Navbar />
          <Lead />     
          </>}>
         
         
        </Route>
        <Route path="/lead/:id"
        element={<> 
          <Navbar />
          <Leaddataupdate />    
          </>}>
         
          
        </Route>
        <Route exact path="/taskdataentry"
        element={<> 
          <Navbar />
          <CreateTask />      
          </>}>
         
   
        </Route>
        <Route path="/taskdataentry/:id"
        element={<> 
          <Navbar />
          <UpdateTask />    
          </>}>
         
         
        </Route>
        <Route exact path="/listtaskdata"
        element={<> 
          <Navbar />
          <Listtaskdata />    
          </>}>
        
          
        </Route>
        <Route exact path="/listassetdata"
        element={<> 
          <Navbar />
          <Listassetdata />    
          </>}>
        
          
        </Route>
        <Route path="/custdataentry/:id"
        element={<> 
          <Navbar />
          <Custdataupdate />   
          </>}>
        
            
        </Route>
        <Route exact path="/custdataentry"
        element={<> 
          <Navbar />
          <Custdataentry />   
          </>}>
         
           
        </Route>
        <Route exact path="/searchcust"
        element={<> 
          <Navbar />
          <Searchcust />   
          </>}>
         
          
        </Route>
        <Route path="/tripdataentry/:id/payments"
        element={<> 
          <Navbar />
          <Trippayments />    
          </>}>
          
         
        </Route>
        <Route path="/tripdataentry/:id/paymentupdate"
        element={<> 
          <Navbar />
          <Trippaymentupdate />    
          </>}>
        
          
        </Route>
        <Route path="/tripdataentry/:id/invoice"
        element={<> 
          <Navbar />
          <Invoice />   
          </>}>
      
           
        </Route>
        <Route path="/tripdataentry/:id"
        element={<> 
          <Navbar />
          <Tripdataupdate />    
          </>}>
        
         
        </Route>
        <Route exact path="/tripdataentry"
        element={<> 
          <Navbar />
          <Tripdataentry />   
          </>}>

          </Route>

          <Route exact path="/duptourentry/:id"
        element={<> 
          <Navbar />
          <Duptourentry />   
          </>}>
          
         
        </Route>
        <Route exact path="/leadtripdataentry"
        element={<> 
          <Navbar />
          <Leadtripdataentry />   
          </>}>
         
          
        </Route>
        <Route exact path="/postsalesdata"
        element={<> 
          <Navbar />
          <PostSales />   
          </>}>
        
         
        </Route>
        <Route exact path="/duptripentry"
        element={<> 
          <Navbar />
          <Duptripentry /> 
          </>}>
        
        
        </Route>
        <Route exact path="/supplierdataentry"
        element={<> 
          <Navbar />
          <Supplierdataentry />    
          </>}>
         
         
        </Route>
        <Route exact path="/searchtrip"
        element={<> 
          <Navbar />
          <Searchtrip />   
          </>}>
        
           
        </Route>
        <Route exact path="/viewvoucher"
        element={<> 
          <Navbar />
          <Viewvoucher />      
          </>}>
         
          
        </Route>
        <Route exact path="/dashboard"
        element={<> 
          <Navbar />
          <Dashboard />  
          </>}>
         
            
        </Route>
        

        <Route path="/hoteldataentry/:id"
         element={<> 
          <Navbar />
          <Hoteldataupdate />   
          </>}>
        
          
        </Route>
        <Route exact path="/hoteldataentry"
         element={<> 
          <Navbar />
          <Hoteldataentry />  
          </>}>
       
          
        </Route>
        <Route exact path="/searchhotel"
         element={<> 
          <Navbar />
          <Searchhotel />   
          </>}>
         
          
        </Route>

        <Route path="/quotedataentry/:id"
        element={<> 
          <Navbar />
          <Quotedataupdate />   
          </>}>
          
          
        </Route>
        <Route exact path="/quotedataentry"
        element={<> 
          <Navbar />
          <Quotedataentry />    
          </>}>
      
        
        </Route>
        <Route exact path="/viewquote/:id"
        element={<> 
          
          <Viewquote />    
          </>}>
          
         
        </Route>
        <Route path="/reusequote"
        element={<> 
          <Navbar />
          <Reusequote />   
          </>}>
         
          
        </Route>
        <Route path="/productbased"
        element={<> 
          <Navbar />
          <ProductBased />    
          </>}>
          
           
        </Route>

        <Route path="/tourdataentry/:id"
        element={<> 
          <Navbar />
          <Tourdataupdate />     
          </>}>
        
          
        </Route>
        <Route exact path="/tourdataentry"element={<> 
          <Navbar />
          <Tourdataentry />     
          </>}>
         
         
        </Route>
        <Route path="/supplierdataentry/:id"
        element={<> 
          <Navbar />
          <Supplierdataupdate />   
          </>}>
      
        
        </Route>
        <Route path="/supplierdatarecord/:id"
        element={<> 
          <Navbar />
          <Supplierdatarecord />   
          </>}>
       
        
        </Route>

        <Route path="/employeedataentry/:id"
        element={<> 
          <Navbar />
          <Employeedataupdate />    
          </>}>
         
           
        </Route>
        <Route exact path="/employeedataentry"
        element={<> 
          <Navbar />
          <Employeedataentry />   
          </>}>
        
           
        </Route>
        <Route path="/listemployeedata"
        element={<> 
          <Navbar />
          <Listemployeedata />     
          </>}>
         
          
        </Route>

        <Route path="/canddataentry/:id"
        element={<> 
          <Navbar />
          <Canddataupdate />    
          </>}>
          
           
        </Route>
        <Route exact path="/canddataentry"
        element={<> 
          <Navbar />
          <Canddataentry />     
          </>}>
         
         
        </Route>
        <Route path="/listhrdata"
        element={<> 
          <Navbar />
          <Listhrdata />    
          </>}>
          
           
        </Route>

        <Route path="/fddataentry/:id"
        element={<> 
          <Navbar />
          <Fd />   
          </>}>
         
          
        </Route>
        <Route exact path="/fddataentry"
        element={<> 
          <Navbar />
          <Fdentry />    
          </>}>
         
          
        </Route>
        <Route path="/listfddata"
        element={<> 
          <Navbar />
          <Listfddata />    
          </>}>
          
          
        </Route>

        <Route path="/listquotedata"
        element={<> 
          <Navbar />
          <Listquotedata />     
          </>}>
          
          
        </Route>
        <Route path="/analyticsdata"
        element={<> 
          <Navbar />
          <Analyticsdata/>     
          </>}>
          
         
         
        </Route>
        <Route path="/analyticsadmin"
        element={<> 
          <Navbar />
          <Analyticsdata2/>   
          </>}>
          
           
          
        </Route>
        <Route path="/productanalytics"
        element={<> 
          <Navbar />
          <Productanalytics/>    
          </>}>
          
           
         
        </Route>

        <Route path="/listhoteldata"
        element={<> 
          <Navbar />
          <Listhoteldata />   
          </>}>
         
          
        </Route>
        <Route path="/listtourdata"
        element={<> 
          <Navbar />
          <Listtourdata />    
          </>}>
       
        
        </Route>
        <Route path="/listcustdata"
        element={<> 
          <Navbar />
          <Listcustdata />     
          </>}>
       
          
        </Route>
        <Route path="/listtripsdata"
        element={<> 
          <Navbar />
          <Listtripsdata />  
          </>}>
         
           
        </Route>
        <Route path="/listsupplierdata"
        element={<> 
          <Navbar />
          <Listsupplierdata />     
          </>}>
          
         
        </Route>

        <Route exact path="/knowledge/dubai"
        element={<> 
          <Navbar />
          <Dubai />  
          </>}>
          
            
        </Route>
        <Route exact path="/knowledge/himachal"
        element={<> 
          <Navbar />
          <Himachal />    
          </>}>
        
           
        </Route>
        <Route exact path="/knowledge/andaman"
        element={<> 
          <Navbar />
          <Andaman />    
          </>}>
        
         
        </Route>
        <Route exact path="/knowledge/thailand"
        element={<> 
          <Navbar />
          <Thailand />     
          </>}>
          
          
        </Route>
        <Route exact path="/knowledge/goa"
        element={<> 
          <Navbar />
          <Goa />   
          </>}>
          
           
        </Route>
        <Route exact path="/knowledge/kashmir"
        element={<> 
          <Navbar />
          <Kashmir />    
          </>}>
        
          
        </Route>
        <Route exact path="/knowledge/SriLanka"
        element={<> 
          <Navbar />
          <SriLanka />   
          </>}>
         
           
        </Route>
        <Route exact path="/knowledge/kerala"
        element={<> 
          <Navbar />
          <Kerala />  
          </>}>
         
           
        </Route>
        <Route exact path="/knowledge/sikkim-darjeeling"
        element={<> 
          <Navbar />
          <Sikkim />   
          </>}>
          
         
        </Route>
        <Route exact path="/knowledge/singapore"
        element={<> 
          <Navbar />
          <Singapore />   
          </>}>
         
           
        </Route>
        <Route exact path="/knowledge/malaysia"
        element={<> 
          <Navbar />
          <Malaysia />   
          </>}>
         
          
        </Route>
        <Route exact path="/knowledge/indonesia"
        element={<> 
          <Navbar />
          <Indonesia />   
          </>}>
        
       
        </Route>
        <Route exact path="/knowledge/ladakh"
         element={<> 
          <Navbar />
          <Ladakh />    
          </>}
        >
        </Route>
        <Route exact path="/knowledge/vietnam"
         element={<> 
          <Navbar />
          <Vietnam />     
          </>}
        >
          
        </Route>
        <Route exact path="/knowledge/azerbaijan"
        element={<> 
          <Navbar />
          <Azerbaijan />    
          </>}
        > 
        </Route>
        <Route exact path="/knowledge/kazakhstan"
        element={<> 
          <Navbar />
          <Kazakhstan />   
          </>}
        >
         
        </Route>
        <Route exact path="/knowledge/turkey" 
        element={<> 
          <Navbar />
           <Turkey />  
          </>}>
         
          
        </Route>
        <Route path="/bulkmsg" 

        element={<> 
          <Navbar />
          <BulkWA />  
          </>}>
        </Route>
        <Route path="/test" element={<Test /> }>
          
         
        </Route>
        
        <Route path="*" element={<Pagenotfound /> }>
           
        </Route>
        <Route path="/projects"
        element={<> 
          <Navbar />
          <Project />    
          </>}>
       
        
        </Route>
      </Routes>
      </AppDataProvider>
      </AuthContextProvider>
   
    </div>
    </Router>

    
  );
}

export default App;
